export const APPENDIX_CONTENT = `
Despite these gaps, the literature identifies promising models and approaches:

#### Community-Controlled Models

ACCHOs demonstrate that community governance and Indigenous leadership create more culturally safe training environments with more robust support structures. These organisational models offer valuable lessons for strengthening cultural safety in all training settings.

#### Peer Support Networks

Networks provide valuable peer support and advocacy for Indigenous practitioners, demonstrating the importance of identity-based mentorship and connection.

#### Immersive Learning

Experiential learning through ACCHO/AMS placements is consistently described as transformative for non-Indigenous registrars, highlighting the value of relationship-based, contextual learning.

#### Targeted Programs

Targeted support tailored to specific contexts (e.g., remote practice) can effectively address unique workforce challenges.

#### Cultural Educator Roles

Where adequately resourced and supported, Cultural Educators and Cultural Mentors provide essential educational infrastructure that enables effective training in Indigenous health.

### Moving from Description to Intervention

The literature has effectively mapped the terrain of challenges. The critical need now is for research that moves beyond description to test and evaluate interventions that can strengthen support for First Nations GP training.
`;
